<template>
  <div>
    <!-- 菜单 -->
    <my_menu2 page_name="万能表单" back_type="close" back_icon="md-close"></my_menu2>
    <div style="height: 50px"></div>
    <div class="options">
      <Button type="primary" size="small" style="font-size: 13px" @click="add_template">
        <Icon type="ios-add-circle-outline" /> 制作新模板
      </Button>
    </div>
    <div class="table_div">
      <Table border ref="selection" :columns="columns" size="small" :data="table_data">
        <template #qrcode="{ row }">
          <div>
            <Button size="small" type="primary" style="font-size: 13px" @click="view_qrcode(row)">
              <Icon type="ios-eye-outline" />查看二维码
            </Button>
          </div>
        </template>
        <template #view_data="{ row }">
          <Button @click="view_data(row)" size="small" ype="primary" style="font-size: 13px">查看数据</Button>
        </template>
      </Table>
    </div>
    <Drawer title="表单数据" :closable="true" v-model="view_data_show" width="90">
      <div class="view_data_export">
        <span class="view_data_export_btn" @click="export_csv">
          <Icon type="ios-cloud-download-outline" />导出表格
        </span>
      </div>
      <Table ref="table1" border :columns="view_form_data_colunms" size="small" :data="view_form_table_data"
        :height="windowHeight - 110">
        <!-- <template v-for="(key, index) in slot_key_list" #[key]="{ row }">
          <Button>{{ row }}查看</Button>
        </template> -->

        <template v-for="(slotName, index) in slot_key_list" v-slot:[slotName]="{ row }">
          <Button size="small" @click="view_img(row[slotName])" style="font-size: 13px;">查看</Button>
        </template>
        <!-- <template v-for="(item, i) in view_form_data_colunms" v-if="item.slot" v-slot:[item.key]="{ row }">
          <Button size="small" @click="view_img(row)">查看</Button>
        </template> -->


        <!-- <template v-for="(key, index) in slot_key_list" v-slot:[key]="{ row }">
          <Button>{{ row }}查看</Button>
        </template> -->
      </Table>
    </Drawer>

    <Drawer title="制作新模板" :closable="true" v-model="add_show" width="80">
      <div>
        <div class="sm">
          使用说明：点击或者拖拽左侧组件，可以组合成一个表单模板，支持拖拽上下排序，生成后可扫码填写，员工在线填写提交，后台支持导出Excel。
        </div>
        <div>
          <div>
            <div class="move_list">
              <div>
                <div class="zujian_title">组件列表</div>

                <VueDraggable v-model="field_list" :animation="150"
                  :group="{ name: 'people', pull: 'clone', put: false }" :sort="false" class="" @clone="onClone">
                  <div v-for="item in field_list" :key="item.move_id" class="cursor_move"
                    :style="'background:' + item.field_bg_color">
                    <div class="" @click="click_cursor(item)">
                      <span :class="'iconfont ' + item.field_icon"></span>
                      {{ item.field_name }}
                    </div>
                    <div>
                      {{ item.remarks }}
                    </div>
                  </div>

                </VueDraggable>
              </div>
              <div class="right_field_div">
                <div class="zujian_title">生成表单</div>
                <VueDraggable v-model="form_field_list" :animation="150" group="people" class="">
                  <div v-for="(item, i) in form_field_list" :key="item.move_id" class="cursor_move2">
                    <div class="input_1">
                      <div class="number">{{ i + 1 }}</div>
                      <Input v-model="item.title" placeholder="请输入字段标题，如姓名等" style="width: 100px" />
                      <span style="font-weight: 600; color: #000; margin: 0 5px">:</span>
                    </div>
                    <div class="move3" :style="'background:' + item.field_bg_color">
                      {{ item.field_name }}
                      <div style="margin-left: 10px; font-weight: 600">
                        <Icon size="24" color="#fff" type="ios-list" />
                      </div>
                    </div>
                    <div class="del_btn" @click="del_field(i)">
                      <Icon size="16" color="red" type="ios-trash-outline" />
                      <span class="del_txt">删除</span>
                    </div>
                  </div>
                </VueDraggable>
              </div>
            </div>
            <!-- <div class="flex justify-between">
              <preview-list :list="list1" />
              <preview-list :list="list2" />
            </div> -->
          </div>
        </div>
        <div class="submit_btn_div">
          <Button @click="add_form_btn" type="primary">确认生成新表单</Button>
        </div>
      </div>
    </Drawer>
    <Modal v-model="view_qrcode_show" title="查看二维码" :mask-closable="false" :footer-hide="true" width="350">
      <div>
        <div class="view_qr_txt">
          名称可在输入框中修改，可截图保存!<span class="copytxt" @click="copy">
            <Icon type="ios-link" />复制链接
          </span>
        </div>
        <Input v-model="view_qrcode_item.qr_name" placeholder="请输入二维码名称..." style="width: 320px" />
      </div>
      <div class="qrcode_box">
        <div ref="qrCodeUrl" class="qrcode_img" alt=""></div>
      </div>
      <div class="qrname">
        {{ view_qrcode_item.qr_name }}
      </div>
    </Modal>

    <Modal v-model="add_form_name_show" title="确认生成新表单" :mask-closable="false" :footer-hide="true" width="300">
      <div>
        <Input v-model="form_name" placeholder="请给表单起个名字..." style="width: 265px" />
      </div>
      <div class="submit_btn_div2">
        <Button type="primary" @click="add_form_request">确认生成</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import my_menu2 from "@/component/menu/menu2.vue";
import { http, open_new_page, get_view_file_url } from "@/utils/http.js";
import { VueDraggable } from "vue-draggable-plus";
import QRCode from "qrcodejs2";

export default {
  components: {
    my_menu2,
    VueDraggable,
  },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
      field_list: [],
      form_field_list: [],

      add_show: false,
      page: 1,
      limit: 20,

      columns: [],
      table_data: [],

      form_name: "",
      add_form_name_show: false,

      view_qrcode_show: false,
      view_qrcode_item: {
        qr_name: "",
      },
      qrtxt: "",
      view_data_show: false,
      view_form_table_data: [],
      view_form_data_colunms: [],
      slot_key_list: [],
      current_form_id: "",

      project_id: ""
    };
  },
  mounted() {
    var query = this.$route.query
    this.project_id = query.project_id
        this.get_field_list();

    this.get_table_data();

  },
  methods: {

    view_data(item) {
      console.log(item)
      this.view_data_show = true
      this.current_form_id = item.form_id
      this.view_form_data(item.form_id, 0)
    },
    view_form_data(form_id, down_status) {
      var that = this;
      var obj = {
        form_id: form_id,
        down_status: down_status
      };
      http("post", process.env.VUE_APP_HOST + "/tools/universal_form/view_form_data", obj, true)
        .then((res) => {
          if (res.code == 0) {
            console.log(res)
            that.view_form_data_colunms = res.data.columns;
            that.view_form_table_data = res.data.resp_list
            that.slot_key_list = res.data.slot_key_list
            console.log(that.slot_key_list)
            if (res.data.export_url != '') {
              get_view_file_url(res.data.export_url)
            }
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    view_qrcode(item) {
      this.view_qrcode_show = true;
      this.view_qrcode_item = item;
      //   this.view_qrcode_item.qr_name = item.name;
      this.view_qrcode_item.qr_name = '微信扫描二维码，填写信息';
      var that = this;
      var qrtxt = item.qrcode_txt;
      this.qrtxt = qrtxt;
      that.$refs.qrCodeUrl.innerHTML = "";
      var qrcode = new QRCode(that.$refs.qrCodeUrl, {
        text: qrtxt, // 需要转换为二维码的内容
        width: 149,
        height: 148,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },

    add_form_btn() {
      console.log(this.form_field_list);
      this.add_form_name_show = true;
    },

    add_form_request() {
      if (this.form_field_list.length == 0) {
        this.$Message.error("请至少添加一个组件");
        return;
      }

      var that = this;
      var obj = {
        form_field_list: this.form_field_list,
        form_name: this.form_name,
        project_id: this.project_id
      };
      http("post", process.env.VUE_APP_HOST + "/tools/universal_form/form_add", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.add_show = false;
            that.add_form_name_show = false;
            that.get_table_data();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    // 获取字段数据
    get_field_list() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/tools/universal_form/field_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.field_list = res.data.field_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    // 获取表单
    get_table_data() {
      var that = this;
      var obj = {
        page: this.page,
        limit: this.limit,
        project_id: this.project_id
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/tools/universal_form/form_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.columns = res.data.columns;
            that.table_data = res.data.resp_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    onClone(e) {
      console.log(e);
    },
    add_template() {
      this.add_show = true;
      this.get_field_list();
    },

    //点击组件，则在右侧添加
    click_cursor(item) {
      item["move_id"] = Math.random().toString();
      this.form_field_list.push(JSON.parse(JSON.stringify(item)));
    },

    del_field(index) {
      this.form_field_list.splice(index, 1);
    },

    copy() {
      this.$Copy({
        text: this.qrtxt,
      });
    },
    export_csv() {
      this.view_form_data(this.current_form_id, 1)


    },

    view_img(value) {
      this.$ImagePreview.show({
        previewList: [value]
      });


    }

  },
};
</script>

<style scoped>
.copytxt {
  cursor: pointer;
  color: #0466dd;
  margin-left: 10px;
}

.qrname {
  margin-top: 10px;
  margin-bottom: 20px;
  text-align: center;
  font-weight: 600;
  color: #333;
  font-size: 16px;
}

.view_data_export_btn {
  color: #0466dd;
  cursor: pointer;
  margin-bottom: 5px;
}

.view_data_export {
  display: flex;
  justify-content: flex-end;
}

.view_qr_txt {
  border-radius: 5px;
  margin-bottom: 5px;
  font-size: 13px;
  padding: 5px;
  background: #d9eaff;
}

.qrcode_box {
  margin-top: 40px;
  display: flex;
  justify-content: center;
}

.qrcode_img {
  width: 150px;
  height: 150px;
}

.submit_btn_div2 {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.table_div {
  padding: 10px;
}

.input_1 {
  display: flex;
  align-items: center;
}

.del_btn {
  margin-left: 10px;
  cursor: pointer;
}

.del_btn:hover span {
  color: red;
}

.del_txt {
  color: #fd9999;
  font-size: 13px;
  margin-left: 3px;
}

.number {
  width: 15px;
  color: #ececec;
  margin-right: 10px;
}

.right_field_div {
  margin-left: 20px;
  border-left: 1px solid #ccc;
  padding-left: 20px;
}

.cursor_move {
  padding: 5px 10px;
  margin-bottom: 10px;
  color: #fff;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-size: 13px;
}

.cursor_move:hover {
  background: #0466dd;
  color: #fff;
  cursor: move;
}

.cursor_move2 {
  display: flex;
  align-items: center;
  padding: 5px 2px 5px 0px;
  margin-bottom: 3px;
  border-radius: 5px;
  font-size: 13px;
}

.submit_btn_div {
  position: fixed;
  bottom: 15px;
  display: flex;
  width: calc(80% - 50px);
  justify-content: flex-end;
  background: #fff;
  padding-top: 10px;
  border-top: 1px dashed #ccc;
}

.move3 {
  display: flex;
  justify-content: space-between;
  width: 200px;
  align-items: center;
  padding: 5px 0px 5px 10px;
  color: #fff;
  border-radius: 3px;
}

.cursor_move2:hover {
  cursor: move;
}

.move_list {
  display: flex;
}

.zujian_title {
  text-align: center;
  font-weight: 600;
  margin-bottom: 10px;
}

.options {
  padding: 5px 0 0 0;
  padding: 0 10px;
  display: flex;
  justify-content: flex-end;
}

.sm {
  font-size: 13px;
  padding: 5px;
  color: #333;
  background: #e5f1ff;
  margin-bottom: 10px;
  border-radius: 3px;
}
</style>
